module.exports = __webpack_public_path__ + "img/page-device-order-list-qrcode.f4098426.png";